import { shade } from 'polished';
import styled from 'styled-components';

export const Card = styled.div`
    border-top: 0.5vh solid ${props => props.theme.palette.primary.main};
    width: 100%;
    height: 100%;
    background-color: ${props => {
        const color = props.theme.palette.primary.main;
        return shade(0.95, color);
    }};
    color: #fff;
    padding: 1.5vh 1vw;
    margin: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content {
        height: 100%;
        width: 100%;
        display: flex;
        flex: 1 1;
        padding: 0px;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .title {
            color: #fff;
            font-size: 1.35vh !important;
        }

        .big-value {
            font-size: 2.5vh;
            span {
                margin-top: 0.5vh;
            }
        }
    }
`;

export const ChatDialog = styled.div`
    .chat-main {
        display: flex;
        margin-bottom: -15px;
        flex-direction: row;
        height: 40vh;
    }

    .chat-main-scroll {
        background-color: #000;
        min-height: 50%;
    }

    .chat-side {
        border-left: 1px solid ${props => props.theme.palette.primary.main};
        background-color: #000;

        .chat-side-title {
            font-weight: bold;
            color: #fff !important;
            margin-top: 15px;
            width: 100%;
            text-align: center;
        }

        .chat-side-content {
            padding: 30px 15px 30px 15px;
            display: flex;
            flex-direction: column;
            align-items: end;
        }
    }

    .chat-header {
        width: 100%;
        border-bottom: 1px solid ${props => props.theme.palette.primary.main};
        background-color: #000;
        padding: 16px 16px 16px 32px;

        .chat-header-info {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }
    }

    .chat-footer {
        border-top: 1px solid ${props => props.theme.palette.primary.main};
        background-color: #000;
        z-index: 1000;
    }

    textarea {
        border-radius: 1.5vh;
        padding: 1vh 2vh 1vh 2vh;
    }

    .MuiIconButton-label {
        color: ${props => props.theme.palette.primary.main};
    }

    .MuiSelect-select.MuiSelect-select {
        padding-right: 0px;
    }

    .MuiSelect-icon {
        display: none;
    }
`;

export const MainArea = styled.div`
    height: 100%;
    display: flex;
    flex-direction: ${props => (props.smallScreen ? 'column-reverse' : 'row')};

    .chat-main-content {
        padding-top: 30px;
        padding-bottom: ${props => (props.smallScreen ? '15px' : '50px')};
        padding-left: ${props => (props.smallScreen ? '20px' : '0px')};
    }

    .chat-item .bubble {
        background-color: ${props => props.theme.palette.primary.main};
        padding: 12px;
        margin-left: 0px;

        .text-muted {
            color: #ccc !important;
            font-size: smaller;
        }
    }
`;

export const MessagesArea = styled.div`
    height: ${props => (props.smallScreen ? '85%' : '100%')};
`;

export const MessageShortcut = styled.div`
    background-color: ${props => props.theme.palette.primary.main};
    border-radius: 5px;
    color: #fff;
    padding: 12px;
    font-weight: ${props => {
        return props.bold ? 'bold' : 'regular';
    }};

    :hover {
        cursor: pointer;
        font-weight: bold;
        border: 1px solid #fff;
    }
`;

export const FaceArea = styled.div`
    height: ${props =>
        props.smallScreen && !props.showFaces ? '15%' : '100%'};
    display: flex;
    align-items: ${props => (props.smallScreen ? 'center' : 'flex-end')};
`;

export const GallerySelector = styled.div`
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.palette.primary.main};
`;

export const AvatarArea = styled.div`
    display: flex;
    align-items: ${props => (props.smallScreen ? 'center' : 'flex-end')};
    width: ${props => (props.smallScreen ? '40%' : '100%')};
`;

export const FaceAvatar = styled.img`
    border: 2px solid ${props => props.theme.palette.primary.main};
    border-radius: 50%;
    width: 100%;
    max-height: 100%;
    aspect-ratio: 1 / 1;
    object-fit: contain;
    background-color: #000;

    :hover {
        cursor: pointer;
        border: 1px solid #fff;
    }
`;

export const FaceShortcut = styled.img`
    border: 1px solid ${props => props.theme.palette.primary.main};

    :hover {
        cursor: pointer;
        border: 1px solid #fff;
    }
`;
